import React, { useState } from "react";
import  martin2 from '../../../assets/specialists/Martin_2.png';
import  andrea1 from '../../../assets/specialists/Andrea_2.png';
import  carla1 from '../../../assets/specialists/Carla_2.png';
import  jessica1 from '../../../assets/specialists/Jessica_2.png';
import  patricia1 from '../../../assets/specialists/Patriscia_2.png';
import sandra from '../../../assets/specialists/Sandra_2.png';
import gabriela from '../../../assets/specialists/Gabriela_2.png';
import carolina from '../../../assets/specialists/Carolina.jpg';


import "./carrusel_and_card_hover.css";

const specialists = [
  {
    name: "Martin Olea",
    img: martin2,
    description:
      "Martín es consultor y asesor organizacional senior con más de 20 años de experiencia, especializado en la Gestión del Aprendizaje y Desarrollo del Talento. Ha liderado equipos, proyectos y soluciones estratégicas. Es facilitador, docente y speaker. Es licenciado en Psicología Educativa por la Universidad Cayetano Heredia y maestro en Educación por la Universidad de Piura. Actualmente, es Director de L&D en One Learning.",
    description2:
    "Martin trabajó con: Alicorp, Belcorp, BCP, Credicorp, Molycop, Yanbal, Ferreyros, Izipay, Grupo Interbank, Opella, Real Plaza, entre otros."
  },
  {
    name: "Andrea Stepanek",
    img: andrea1,
    description:
      "Andrea es especialista senior en soluciones de desarrollo y aprendizaje corporativo, así como en gestión de calidad educativa. Como facilitadora y diseñadora instruccional senior, se enfoca en programas de liderazgo y habilidades socioemocionales, con especialización en seguridad psicológica e inclusión. Está certificada en mentoring profesional (HCN World, Chile), coaching aplicado, facilitación y diseño de workshops con Lego® Serious Play®️, y es facilitadora Points Of You®️. Es socia fundadora de Rubik Consulting. ",
    description2:
    "Andrea trabajó con: Belcorp, UCIC, Cencosud, Cineplanet. UTP, Stracon, Apuesta Total, San Fernando, ISM, entre otros."
  },
  {
    name: "Carla Melgar",
    img: carla1,
    description:
  "Carla es administradora de empresas, especializada en Recursos Humanos y con máster en Desarrollo Organizacional y Dirección de Personas. Cuenta con más de 10 años de experiencia en gestión de talento, liderando estrategias de desarrollo de competencias, gestión del desempeño, capacitación y gestión del cambio. Ha dirigido proyectos clave como la formación de equipos de entrenamiento para fuerza comercial y la ejecución de planes de gestión del cambio en proyectos comerciales y de transformación.",
description2: "Carla trabajó con: BanBif, Rimac, Deloitte, Alicorp, ISM, Molitalia, Cencosud, entre otras."  },
  {
    name: "Jessica Delfino",
    img: jessica1,
    description:
    "Jessica es psicóloga ocupacional y conferencista con más de 17 años de experiencia, especializada en prevención del acoso sexual laboral y riesgos psicosociales. Certificada como capacitadora SafeStart, se enfoca en Seguridad Basada en el Comportamiento, bienestar y manejo de la fatiga. Ha impartido charlas para diversos niveles y sectores, incluyendo minería, automotriz y manufactura. Además, es docente en la Universidad Peruana Cayetano Heredia y miembro de la junta directiva de la Asociación Peruana de Psicología de la Seguridad y Salud en el Trabajo, donde lidera investigaciones sobre clima laboral y prevención de riesgos.",
  description2:
"Jessica trabajo con: Tottus, Antamina, Derco, Las Bambas, Clínica Internacional, Nissan, Aluminios de Uruguay, entre otros. "  },
  {
    name: "Patriscia Ramos",
    img:patricia1,
    description:
    "Patriscia es especialista en desarrollo humano y bienestar organizacional, con experiencia en entornos educativos y corporativos. Facilita y diseña talleres vivenciales, y ofrece consultoría en liderazgo consciente, creatividad, comunicación efectiva, trabajo colaborativo y gestión emocional. Emplea metodologías participativas que promueven la reflexión profunda, el aprendizaje transformador y la conexión auténtica entre personas y equipos. Licenciada en Psicología Clínica de la PUCP, terapeuta en Artes Expresivas y tiene una maestría en Coaching y Consultoría con enfoque en artes expresivas, formada en Suiza.",
    description2:
    "Patriscia trabajó con: Clínica Internacional, Río Tinto, UPC, Las Bambas, Avianca, Entel, EY, UCAL, Minedu, Ankay, Banco Falabella, PUCP, entre otras."
  },
    {
    name: "Gabriela Gutiérrez",
    img: gabriela,
    description:
    "Gabriela es experta senior de recursos humanos y bienestar integral. Acompaña el desarrollo organizacional desde la gestión del liderazgo, clima laboral y cultura para mejorar el bienestar. Sus abordajes son principalmente prácticos. Es magíster en Desarrollo Organizacional y Dirección de Personas, Licenciado en Psicología Organizacional con una diplomatura en Medicina del Estrés, con formación en Perú, Chile y Argentina.",
    description2:
  "Gabriela trabajó con: BCP, Iron Mountain, Cinemark, Alicorp, UPC, COISAV, Tgestiona, Austral Group, Archroma, entre otros."  },
    {
    name: "Sandra Cárdenas",
    img:sandra,
    description:
      "Sandra es consultora y recruiter senior, con experiencia en recursos humanos gestionando Atracción & Selección, Mentoring Profesional y Gestión del Cambio. Destaca por diseñar estrategias efectivas para atraer y desarrollar talento, así como por mejorar la experiencia y el compromiso de los colaboradores, equipos y líderes. Posee una maestría en Recursos Humanos y formación en Psicología Organizacional y Gestión del Talento. Además de certificaciones en Metodología de Entrevista por Competencias y Gestión de Proyectos a través del Design Thinking.",
      description2:
      "Sandra ha trabajado con: Alicorp, Delosi, Qroma, Aceros Arequipa, UTEC, HR LATAM, Dirección Estratégica."
  },
  {
    name: "Carolina Torres",
    img:carolina,
    description:
    "Carolina es speaker, facilitadora, consultora y especialista en Gestión Humana y proyectos tecnológicos, con más de diez años de experiencia acompañando transformaciones en distintos sectores a nivel regional. Cuenta con una sólida trayectoria en Gestión del Cambio enfocada en las personas, aplicando estrategias ágiles que impulsan la adaptabilidad organizacional y una toma de decisiones más efectiva. Ha liderado equipos, proyectos y estrategias en empresas de los sectores consultoría, banca, manufactura y retail, entre otros.",
      description2:
      "Es Licenciada en Psicología Organizacional y actualmente cursa un Máster en Proyectos Ágiles en EGADE Business School (Tecnológico de Monterrey). Como speaker y organizadora en LATAM, forma parte del equipo de TEDx Real del Mayorazgo (México). Actualmente se desempeña como Lead Change Management en Act Digital."
  }
];

const TeamCarousel_merged = () => {
  const [index, setIndex] = useState(0);

  const prev = () => {
    setIndex((prev) => (prev - 1 + specialists.length) % specialists.length);
  };

  const next = () => {
    setIndex((prev) => (prev + 1) % specialists.length);
  };

  const getClassName = (i) => {
    if (i === index) return "team-card team-center";
    if (i === (index - 1 + specialists.length) % specialists.length)
      return "team-card team-left1";
    if (i === (index - 2 + specialists.length) % specialists.length)
      return "team-card team-left2";
    if (i === (index + 1) % specialists.length) return "team-card team-right1";
    if (i === (index + 2) % specialists.length) return "team-card team-right2";
    return "team-card team-hidden";
  };

  return (
    <div className="team-carousel-container">
      <button className="team-btn prev" onClick={prev}>
        ◀
      </button>

      <div className="team-carousel-track">
        {specialists.map((person, i) => (
          <article key={i} className={getClassName(i)}>
            <div
              className="thumb"
              style={{ backgroundImage: `url(${person.img})` }}
              onClick={() => setIndex(i)}
            ></div>
            <div className="infos">
              <h2 className="title">
                {person.name}
                <span className="flag"></span>
              </h2>
              <div className="details" style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "20px"}}>
                <p className="txt">{person.description}</p>
              <p className="txt">{person.description2}</p>
              </div>
              
            </div>
          </article>
        ))}
      </div>

      <button className="team-btn next" onClick={next}>
        ▶
      </button>
    </div>
  );
};

export default TeamCarousel_merged;
